import intl from 'react-intl-universal';
import {
  validDetailNotRequire,
  validDetailRequire,
  ReverseResonCodeQT,
} from '@/pages/reservation/roomExchange/helper';

export default {
  checkAdjustListValid: (list) => {
    let isValid = true;
    let msg = '';
    if (list.length) {
      list.forEach((item) => {
        const { adjustReason, adjustRemarks } = item;
        if (!adjustReason) {
          isValid = false;
          msg = intl.get('drawer_checkout_not_select_reverse_reason');
        }
        if (adjustReason !== ReverseResonCodeQT) {
          if (validDetailNotRequire(adjustRemarks)) {
            isValid = false;
            msg = intl.get('bill_credit_please_input_carefully');
          }
        } else {
          if (validDetailRequire(adjustRemarks)) {
            isValid = false;
            msg = intl.get('bill_credit_please_input_carefully');
          }
          if (!adjustRemarks || adjustRemarks.trim().length === 0) {
            isValid = false;
            msg = intl.get('drawer_checkout_not_input_reverse_remarks');
          }
        }
      });
    }
    return { isValid, msg };
  },
};
